import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Hero } from '../components/Hero';
import { SectionLabel } from '../components/SectionLabel';
const sectionIndex = [{
  to: '/about',
  title: 'About',
  text: '45+ years across government relations, transformation and crisis communications.'
}, {
  to: '/executive-profile',
  title: 'Executive Profile',
  text: 'Four strategic pillars defining the scope of executive authority held.'
}, {
  to: '/experience',
  title: 'Experience & Governance',
  text: 'Board, federal, state agency and military command appointments.'
}, {
  to: '/skills',
  title: 'Skills & Endorsements',
  text: '55+ professional competencies endorsed by senior peers and colleagues.'
}, {
  to: '/education',
  title: 'Education',
  text: 'Oklahoma State University and the University of Central Oklahoma.'
}, {
  to: '/advisory',
  title: 'Advisory & Strategy',
  text: 'Blue-Water Strategies — board, advisory and keynote engagements.'
}, {
  to: '/books-and-media',
  title: 'Books & Media',
  text: 'Three published works and speaker bureau representation.'
}, {
  to: '/honors',
  title: 'Honors & Distinctions',
  text: 'Legion of Merit, Bronze Star and national public service awards.'
}, {
  to: '/contact',
  title: 'Executive Inquiry',
  text: 'Board appointments, advisory consultations and speaking engagements.'
}];
export function Home() {
  return <>
      <Hero data-id="element-306" data-mp="2hyyyodmsjfz1" />
      <section className="bg-offwhite py-16 lg:py-24" data-id="element-307" data-mp="2hyp5yiad2upn">
        <div className="mx-auto max-w-shell px-6 lg:px-8" data-id="element-308" data-mp="2d7gy3qoojhel">
          <SectionLabel data-id="element-309" data-mp="2d5w17uew7mdk">Portfolio Sections</SectionLabel>
          <h2 className="mt-5 max-w-3xl font-serif text-3xl leading-tight text-navy sm:text-4xl" data-id="element-310" data-mp="287cf9u0aual7">
            Navigate the record.
          </h2>

          <ul className="mt-12 grid gap-px bg-mist md:grid-cols-2 lg:grid-cols-3" data-id="element-311" data-mp="23aua4t124a8c">
            {sectionIndex.map((item, index) => <li key={item.to} className="bg-white" data-id="element-312" data-mp="1u8l52iok592c" data-mpi={index}>
                <Link to={item.to} className="group flex h-full flex-col p-7 transition-colors duration-150 ease-out hover:bg-navy" data-id="element-313" data-mp="1u94mlyaapvfu">
                  <span className="text-[11px] font-semibold uppercase tracking-overline text-gold-deep group-hover:text-gold-light" data-id="element-314" data-mp="1on3vaairaoef">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="mt-4 font-serif text-xl text-navy group-hover:text-white" data-id="element-315" data-mp="1flw5kgub2vvy">
                    {item.title}
                  </span>
                  <span className="mt-3 text-sm leading-relaxed text-charcoal group-hover:text-slate-300" data-id="element-316" data-mp="28atevugjhick">
                    {item.text}
                  </span>
                  <span className="mt-auto inline-flex items-center gap-2 pt-6 text-sm font-semibold text-navy group-hover:text-gold-light" data-id="element-317" data-mp="1tjkq1nkgo10h">
                    View section
                    <ArrowRightIcon className="h-4 w-4" data-id="element-318" data-mp="2m8roynntusm9" />
                  </span>
                </Link>
              </li>)}
          </ul>
        </div>
      </section>
    </>;
}